import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AccessRightService } from '../AccessRightService';
import { Button, Form, Row } from 'react-bootstrap';
import { IAccessRights } from '../../../model/access-right/IAccessRight';
import { useSelector } from 'react-redux';
import { getCorrectEnums } from '../../../utils/Functions';
import { ErrorToast, SuccessToast } from '../../../utils/toasters';
import CardLayout from '../../../shared/components/CardLayout';

export default function FormAccessRight() {
    const navigate = useNavigate();
    const { id }: any = useParams();
    const { accessRights, SharingTypeEnum } = useSelector((state: any) => state.enums);

    const [accessRight, setAccessRight] = useState<Partial<IAccessRights>>({
        name: 'undefined',
        rights: [],
    });

    useEffect(() => {
        if (!!id) {
            AccessRightService.getAccessRight(+id)
                .then(data => {
                    setAccessRight(data);
                })
                .catch(err => ErrorToast(err));
        }
    }, [id]);

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setAccessRight(prev => {
            if (name === 'rights') {
                return {
                    ...prev,
                    [name]: !!e.target.checked
                        ? [...(accessRight.rights ?? []), value]
                        : accessRight?.rights?.filter(item => item !== value),
                };
            }
            return {
                ...prev,
                [name]: value === 'undefined' ? undefined : value,
            };
        });
    };

    const saveAccessRight = () => {
        const service = !!id
            ? AccessRightService.putAccessRight(+id, accessRight)
            : AccessRightService.postAccessRight(accessRight);

        service
            .then(data => {
                setAccessRight(data);
                SuccessToast(`Successfully ${!!id ? 'updated' : 'created'} access right`);
                navigate('/access-right');
            })
            .catch(err => ErrorToast(err));
    };

    return (
        <CardLayout>
            <h3> {!!id ? 'Update Sharing Right' : 'Create Sharing Right'}</h3>
            <hr />

            <Form.Group className="col-4 mb-4">
                <Form.Select name="name" value={accessRight?.name ?? 'undefined'} onChange={handleChange}>
                    <option value={'undefined'}>Select a user type</option>
                    {!!SharingTypeEnum &&
                        !!SharingTypeEnum.length &&
                        SharingTypeEnum?.map((role: string) => {
                            return (
                                <option key={role} value={role}>
                                    {getCorrectEnums(role)}
                                </option>
                            );
                        })}
                </Form.Select>
            </Form.Group>

            <Row>
                {!!accessRights &&
                    !!accessRights.length &&
                    accessRights?.map((item: string, index: number) => {
                        return (
                            <Form.Group key={index} className="col-6">
                                <Form.Check
                                    label={getCorrectEnums(item)}
                                    value={item}
                                    name="rights"
                                    onChange={(e: any) => handleChange(e)}
                                    checked={accessRight?.rights?.includes(item)}
                                />
                            </Form.Group>
                        );
                    })}
            </Row>

            <div className="mt-5">
                <Button onClick={() => saveAccessRight()}>Save</Button>
            </div>
        </CardLayout>
    );
}
